import React from "react";
import { HiOutlineSun, HiOutlineMoon } from "react-icons/hi";
import { useContext } from "react";
import { Context } from "../Context";
import "../styles/ModeBtn.scss";

const ModeBtn = () => {
  const { darkMode, setDarkMode } = useContext(Context);

  return (
    <div
      className={`switcher  ${darkMode ? "lightBtn" : "darkBtn"}`}
      style={{ color: "white", fontSize: "30px" }}
      onClick={() => setDarkMode(!darkMode)}
    >
      {darkMode ? <HiOutlineSun /> : <HiOutlineMoon />}
    </div>
  );
};

export default ModeBtn;
